import currency from 'currency.js';

/**
 * Rounds a dollar amount to exactly 2 decimal places.
 * Uses currency.js for precise decimal arithmetic.
 *
 * @example roundToCents(10.565) // 10.57
 * @example roundToCents(25.999) // 26
 */
export const roundToCents = (amount: number): number => currency(amount).value;

/**
 * Converts a dollar amount to an integer cents value.
 * Used when APIs require amounts in minor units (e.g., Paysafe).
 *
 * @example dollarsToCents(10.01) // 1001
 * @example dollarsToCents(25.555) // 2556
 */
export const dollarsToCents = (amount: number): number => currency(amount).intValue;

/**
 * Converts a cents value to dollars, rounded to 2 decimal places.
 *
 * @example centsToDollars(1001) // 10.01
 * @example centsToDollars(2556) // 25.56
 */
export const centsToDollars = (cents: number): number => currency(cents, { fromCents: true }).value;
